import { RESET_REVIEWING_REPORT } from "../../actions/mis/reportViewerAction";
import { FETCH_TICKET_DETAILS_START, FETCH_TICKET_DETAILS_SUCCESS, FETCH_TICKET_DETAILS_ERROR, TICKET_DETAILS_RESET, CREATE_TICKET_START, CREATE_TICKET_SUCCESS, CREATE_TICKET_ERROR, FETCH_COMMENTS_START, FETCH_COMMENTS_SUCCESS, FETCH_COMMENTS_ERROR, ADD_COMMENT_START, ADD_COMMENT_SUCCESS, ADD_COMMENT_ERROR } from "../../actions/ticketing/ticketActions";

const INIT_STATE = {
    error: "",
    loading: false,
    commentsLoading: false,
    submittingComment: false,
    showModal: false,
    message: '',
    ticket: null,
    comments: []
};

const ticketDetailsReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case CREATE_TICKET_START:
        case FETCH_TICKET_DETAILS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case CREATE_TICKET_SUCCESS:
        case FETCH_TICKET_DETAILS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, showModal: true, ticket: action.ticket };
        }
        case CREATE_TICKET_ERROR:
        case FETCH_TICKET_DETAILS_ERROR: {
            return { ...state, loading: false, showModal: false, error: action.error, message: '' };
        }
        case RESET_REVIEWING_REPORT:
        case TICKET_DETAILS_RESET: {
            return { ...INIT_STATE };
        }
        case FETCH_COMMENTS_START: {
            return { ...state, commentsLoading: true };
        }
        case FETCH_COMMENTS_SUCCESS: {
            return { ...state, commentsLoading: false, comments: action.comments };
        }
        case FETCH_COMMENTS_ERROR: {
            return { ...state, message: '', commentsLoading: false, error: action.error };
        }
        case ADD_COMMENT_START: {
            return { ...state, submittingComment: true };
        }
        case ADD_COMMENT_SUCCESS: {
            return { ...state, submittingComment: false };
        }
        case ADD_COMMENT_ERROR: {
            return { ...state, message: '', submittingComment: false, error: action.error };
        }
        default:
            return state;
    }
}

export default ticketDetailsReducer;